export enum RequestAbortSignal {
  ChangeLogHistory = 'CHANGE_LOG_HISTORY',
  ExportChangeLogHistory = 'EXPORT_CHANGE_LOG_HISTORY',
  CampaignOptions = 'CHANGE_LOG_HISTORY_CAMPAIGN_OPTIONS',
}
